import DashboardStats from "./DashboardStats";
import WorkflowPipeline from "./WorkflowPipeline";
import StatusChart from "./StatusChart";
import RecentDossiers from "./RecentDossiers";
import CoachWorkload from "./CoachWorkload";
import DashboardAlerts from "./DashboardAlerts";

import "./RoleDashboard.css";

export default function AdminDashboard({ dashboard }) {
  return (
    <div className="role-dashboard">
      <DashboardStats type="admin" stats={dashboard.stats} />

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <WorkflowPipeline items={dashboard.workflow_pipeline} />
        <StatusChart items={dashboard.status_stats} />
      </div>

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <CoachWorkload items={dashboard.dossiers_by_coach} />
        <DashboardAlerts alerts={dashboard.alerts} />
      </div>

      <RecentDossiers dossiers={dashboard.recent_dossiers} />
    </div>
  );
}
